/**
 *
 * Asynchronously loads the component for Webhooks
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Webhooks = lazyLoad(
  () => import('./index'),
  module => module.Webhooks,
);
